import React from 'react';


export default function ArrowArcIcon() {
  return (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 28V12M21.3333 17.3333L16 12L10.6667 17.3333M28 16C28 12.8174 26.7357 9.76516 24.4853 7.51472C22.2348 5.26428 19.1826 4 16 4C12.8174 4 9.76516 5.26428 7.51472 7.51472C5.26428 9.76516 4 12.8174 4 16" stroke="#071013" strokeOpacity="0.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  )
}
